import React, { ReactElement } from "react";

import { ErrorBoundary, FallbackRender, Scope } from "@sentry/react";

import { FallbackErrorScreen } from "@layouts/DashboardLayout/components/FallbackErrorScreen";

import { WithSentryBoundaryOptions } from "@components/withSentryBoundary/types";

export const withSentryBoundary = <P extends object>(
  Component: React.ComponentType<P>,
  { fallback = <FallbackErrorScreen />, tags = {} }: WithSentryBoundaryOptions,
): React.FC<P> => {
  const WrappedComponent: React.FC<P> = (props) => (
    <ErrorBoundary
      fallback={fallback as FallbackRender | ReactElement}
      beforeCapture={(scope: Scope): void => {
        Object.entries(tags).forEach(([key, value]) => {
          scope.setTag(key, value);
        });
      }}
    >
      <Component {...props} />
    </ErrorBoundary>
  );

  WrappedComponent.displayName = `withSentryBoundary(${Component.name})`;

  return WrappedComponent;
};

export default withSentryBoundary;
